import _core from "./core.js";
import _component from "./component.js";
import _index from "./components/index.js";
import _ssr from "./ssr.js";
import _jsx from "./jsx.js";
import _lazy from "./lazy.js";
import _helpers from "./helpers.js";
import _fragment from "./fragment.js";
import _store from "./store.js";
import _context from "./context.js";
import _withStyles from "./withStyles.js";
import _customElementsMode from "./customElementsMode.js";
import _version from "./version.js";
var exports = {};
var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = exports && exports.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERSION = exports.printVersion = exports.defineAsCustomElements = exports.withStyles = exports.useContext = exports.createContext = exports.Store = exports.Fragment = exports.renderSSR = exports.task = exports.nodeToString = exports.hydrateLazy = exports.jsx = exports.isSSR = exports.Component = exports.tick = exports.hydrate = exports.render = exports.h = void 0;
// core
var core_js_1 = _core;
Object.defineProperty(exports, "h", {
  enumerable: true,
  get: function () {
    return core_js_1.h;
  }
});
Object.defineProperty(exports, "render", {
  enumerable: true,
  get: function () {
    return core_js_1.render;
  }
});
Object.defineProperty(exports, "hydrate", {
  enumerable: true,
  get: function () {
    return core_js_1.hydrate;
  }
});
Object.defineProperty(exports, "tick", {
  enumerable: true,
  get: function () {
    return core_js_1.tick;
  }
});
// component
var component_js_1 = _component;
Object.defineProperty(exports, "Component", {
  enumerable: true,
  get: function () {
    return component_js_1.Component;
  }
});
// built-in Components
__exportStar(_index, exports);
// export some defaults (Nano)
const core_js_2 = _core;
Object.defineProperty(exports, "isSSR", {
  enumerable: true,
  get: function () {
    return core_js_2.isSSR;
  }
});
const ssr_js_1 = _ssr;
exports.default = {
  h: core_js_2.h,
  render: core_js_2.render,
  hydrate: core_js_2.hydrate,
  renderSSR: ssr_js_1.renderSSR,
  isSSR: core_js_2.isSSR
};
var jsx_js_1 = _jsx;
Object.defineProperty(exports, "jsx", {
  enumerable: true,
  get: function () {
    return jsx_js_1.jsx;
  }
});
var lazy_js_1 = _lazy;
Object.defineProperty(exports, "hydrateLazy", {
  enumerable: true,
  get: function () {
    return lazy_js_1.hydrateLazy;
  }
});
var helpers_js_1 = _helpers;
Object.defineProperty(exports, "nodeToString", {
  enumerable: true,
  get: function () {
    return helpers_js_1.nodeToString;
  }
});
Object.defineProperty(exports, "task", {
  enumerable: true,
  get: function () {
    return helpers_js_1.task;
  }
});
var ssr_js_2 = _ssr;
Object.defineProperty(exports, "renderSSR", {
  enumerable: true,
  get: function () {
    return ssr_js_2.renderSSR;
  }
});
var fragment_js_1 = _fragment;
Object.defineProperty(exports, "Fragment", {
  enumerable: true,
  get: function () {
    return fragment_js_1.Fragment;
  }
});
var store_js_1 = _store;
Object.defineProperty(exports, "Store", {
  enumerable: true,
  get: function () {
    return store_js_1.Store;
  }
});
var context_js_1 = _context;
Object.defineProperty(exports, "createContext", {
  enumerable: true,
  get: function () {
    return context_js_1.createContext;
  }
});
Object.defineProperty(exports, "useContext", {
  enumerable: true,
  get: function () {
    return context_js_1.useContext;
  }
});
var withStyles_js_1 = _withStyles;
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function () {
    return withStyles_js_1.withStyles;
  }
});
var customElementsMode_js_1 = _customElementsMode;
Object.defineProperty(exports, "defineAsCustomElements", {
  enumerable: true,
  get: function () {
    return customElementsMode_js_1.defineAsCustomElements;
  }
});
// version
var helpers_js_2 = _helpers;
Object.defineProperty(exports, "printVersion", {
  enumerable: true,
  get: function () {
    return helpers_js_2.printVersion;
  }
});
var version_js_1 = _version;
Object.defineProperty(exports, "VERSION", {
  enumerable: true,
  get: function () {
    return version_js_1.VERSION;
  }
});
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  VERSION = exports.VERSION,
  printVersion = exports.printVersion,
  defineAsCustomElements = exports.defineAsCustomElements,
  withStyles = exports.withStyles,
  useContext = exports.useContext,
  createContext = exports.createContext,
  Store = exports.Store,
  Fragment = exports.Fragment,
  renderSSR = exports.renderSSR,
  task = exports.task,
  nodeToString = exports.nodeToString,
  hydrateLazy = exports.hydrateLazy,
  jsx = exports.jsx,
  isSSR = exports.isSSR,
  Component = exports.Component,
  tick = exports.tick,
  hydrate = exports.hydrate,
  render = exports.render,
  h = exports.h,
  Visible = exports.Visible,
  Suspense = exports.Suspense,
  Router = exports.Router,
  Link = exports.Link,
  Img = exports.Img,
  Helmet = exports.Helmet;